import { border, color, display, margin, width } from '@mui/system';
import { colors, fonts } from '../../mui-theme';

const InputStyle = {
    input: {
        width: '100%',
        fontFamily: fonts.fontprimary,
        fontSize: fonts.fontsizesmall,
        display: 'flex',
        flexDirection: 'row',
        height: '55px',
        '& .MuiInputLabel-root': {
            color: colors.colorgrey60,
            fontFamily: fonts.fontprimary,
        },
        '& .MuiInputBase-input': {
            fontFamily: fonts.fontprimary,
            background: colors.colorwhite,
            borderRadius: '4px',
            fontSize: fonts.fontsizesmall,
            padding: '16px',
        },
        '& .MuiOutlinedInput-adornedStart': {
            background: colors.colorwhite,
            paddingLeft: '0',
        },
        '& .MuiOutlinedInput-adornedEnd': {
            background: colors.colorwhite,
            paddingLeft: '0',
        },
        '& label.Mui-focused': {
            color: colors.colorprimary80,
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: colors.colorprimary80,
            },
        },
    },
    error: {
        '& .Mui-error': {
            color: colors.colordanger80,
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: colors.colordanger80,
                borderWidth: '2px',
            },
            '&.Mui-focused': {
                color: colors.colorgrey60,
            },
        },
    },
    dropdown: {
        fontSize: fonts.fontsizebody,
        '& .MuiSelect-select': {
            backgroundColor: 'transparent',
            paddingRight: '28px' + '!important',
            display: 'flex',
        },
        '& .MuiSvgIcon-root': {
            color: colors.colorprimary80,
        },
        '& .MuiInput-root': {
            marginTop: 0,
        },
        '& .MuiInputBase-formControl': {
            width: '100%',
        },
        '& .MuiInput-underline': {
            '&:before': {
                borderBottom: 'none',
            },
            '&:hover': {
                '&:before': {
                    borderBottom: 'none',
                },
            },
            '&:after': {
                borderBottom: 'none',
            },
        },
        '& .MuiSelect-standard': {
            padding: 0,
        },
        '& .MuiInputLabel-root': {
            fontFamily: fonts.fontprimary,
        },
        '& .Mui-disabled': {
            color: colors.colorgrey60,
            borderColor: colors.colorgrey60,

            '& .MuiSelect-icon': {
                color: colors.colorgrey60,
            },
        },
        '&.Mui-selected': {
            backgroundColor: colors.colorsuccess20,
        },
        '&.Mui-focusVisible': {
            backgroundColor: colors.colorwhite,
            '&:hover': {
                backgroundColor: colors.colorsuccess20,
            },
            '&.Mui-selected': {
                backgroundColor: colors.colorsuccess20,
                '&:hover': {
                    backgroundColor: colors.colorsuccess20 + '!important',
                },
            },
        },
        '& .MuiButton-root': {
            minWidth: 0,
            color: colors.colorprimary80,
        },
        '& .MuiSelect-outlined': {
            fontSize: fonts.fontsizebody,
        },
    },
    dropdownStandard: {
        fontSize: fonts.fontsizesmall,
        '& .MuiSelect-outlined': {
            fontSize: fonts.fontsizesmall,
        },
    },
    dropdownIcon: {
        justifyContent: 'center',
        alignItems: 'center',
        color: colors.colorprimary80,
        '& .MuiSelect-outlined': {
            justifyContent: 'center',
            alignItems: 'center',
            color: colors.colorprimary80,
        },
        '& .MuiListItemIcon-root': {
            position: 'absolute',
            left: '16px',
            color: colors.colorprimary80,
        },
    },
    datePicker: {
        '& .MuiInputLabel-root': {
            fontFamily: fonts.fontprimary,
            color: colors.colorblack,
        },
        '& label.Mui-focused': {
            color: colors.colorprimary80,
        },
        '& .MuiOutlinedInput-root': {
            fontFamily: fonts.fontprimary,
            '&.Mui-focused fieldset': {
                borderColor: colors.colorprimary80,
            },
            '& .MuiInputAdornment-root': {
                '& .MuiButtonBase-root': {
                    color: colors.colorprimary80,
                },
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.colorgrey40,
        },
        '& .Mui-focused': {
            '& .MuiInputAdornment-root': {
                '& .MuiButtonBase-root': {
                    color: colors.colorprimary80 + '!important',
                },
            },
        },
        '& .Mui-error': {
            '& .MuiInputAdornment-root': {
                '& .MuiButtonBase-root': {
                    color: colors.colordanger80 + '!important',
                },
            },
        },
    },
    textfield: {
        marginBottom: '16px',

        '&:last-of-type': {
            marginBottom: 0,
        },
        '& .MuiOutlinedInput-root': {
            width: '100%',
        },
    },
    formControl: {
        width: '100%',
        '& .MuiFormControlLabel-root': {
            width: '300px',
        },
    },
    radioButton: {
        '& .MuiRadio-root': {
            padding: '0 9px',
            '&.Mui-checked': {
                color: colors.colorprimary80,
            },
        },
        '& .MuiTypography-root': {
            marginLeft: '24px',
            fontFamily: fonts.fontprimary,
        },
    },
    radioButtonHorizontal: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '280px',

        '& .MuiRadio-root': {
            padding: '0 9px',
            '&.Mui-checked': {
                color: colors.colorprimary80,
            },
        },
        '& .MuiTypography-root': {
            marginLeft: '8px',
            fontFamily: fonts.fontprimary,
        },
    },
    checkbox: {
        alignItems: 'start',
        marginRight: 0,
        width: '100%',

        '& .MuiTypography-root': {
            fontFamily: fonts.fontprimary,
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
        },
        '& .MuiCheckbox-root': {
            color: colors.colorprimary80,
            padding: '0 12px 0 9px',
        },
        '& .Mui-checked': {
            color: colors.colorprimary80,
        },
        '& .MuiCheckbox-indeterminate': {
            color: colors.colorprimary80,
        },
    },
};

export default InputStyle;
